import { UntitledIcon } from '@faceup/icons'
import { ulRefreshCw01 } from '@faceup/icons/ulRefreshCw01'
import { defineMessages, FormattedMessage } from '@faceup/localization'
import { twMerge } from '@faceup/ui'
import { Button } from '@faceup/ui-base'
import { useEffect, useState } from 'react'
import { FullScreenLoader } from './FullScreenLoader'

const messages = defineMessages('followUp.components.routerFullScreenLoader', [
  { id: 'buttonReload', defaultMessage: '' },
] as const)

export const RouterFullScreenLoader = () => {
  const [showButton, setShowButton] = useState<boolean>(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <FullScreenLoader>
      <div
        className={twMerge(
          showButton ? 'opacity-100' : 'opacity-0',
          'transition-opacity absolute mt-32'
        )}
      >
        <Button
          onClick={() => window.location.reload()}
          icon={<UntitledIcon icon={ulRefreshCw01} />}
        >
          <FormattedMessage message={messages.buttonReload} />
        </Button>
      </div>
    </FullScreenLoader>
  )
}
